import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TextareaComponent } from "./textarea.component";
import { LabelModule } from "../label/label.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { StatusModule } from "../status/status.module";

@NgModule({
	declarations: [TextareaComponent],
	imports: [
		CommonModule,
		FormsModule,
		LabelModule,
		HelpTextModule,
		StatusModule
	],
	exports: [TextareaComponent]
})
export class TextareaModule { }
